import { Language } from '@core/shared';

import en from './en/translations.json';
import fr from './fr/translations.json';
import nl from './nl/translations.json';

export const languages: { code: Language; title: string }[] = [
    {
        code: 'nl',
        title: 'Nederlands'
    },
    {
        code: 'en',
        title: 'English'
    },
    {
        code: 'fr',
        title: 'Français'
    }
];

export const defaultResources: { [lng: string]: { translation: { [key: string]: string } } } = {
    en: {
        translation: en
    },
    fr: {
        translation: fr
    },
    nl: {
        translation: nl
    }
};

export const resources: { [lng: string]: { translation: { [key: string]: string } } } = {
    en: {
        translation: { ...en }
    },
    fr: {
        translation: { ...fr }
    },
    nl: {
        translation: { ...nl }
    }
};
